const updateProfileInCache = ({ query, cache, update }) => {
  const { me } = cache.readQuery({ query });
  const newProfile = typeof update === 'function' ? update(me) : update;
  cache.writeQuery({
    query,
    data: { me: { ...me, ...newProfile } },
  });
};

export default updateProfileInCache;
